import React from 'react'

import useGeolocation from '../hooks/useGeolocation'

export const addressCountries = ['FI', 'GB', 'US'] as const

export type AddressCountry = (typeof addressCountries)[number]

export const useAddressesByCountry = ({
  mapsLink,
}: {
  mapsLink: boolean
}): Record<AddressCountry, React.ReactNode> => {
  return {
    FI: (
      <address>
        {mapsLink ? (
          <a
            href="https://maps.app.goo.gl/wzHDdTPpyvaLjfzZ6"
            target="_blank"
            rel="noreferrer"
          >
            Teollisuuskatu 33
          </a>
        ) : (
          <span>Teollisuuskatu 33</span>
        )}
        <br />
        00510 Helsinki, Finland
      </address>
    ),
    GB: (
      <address>
        The Bradfield Centre
        <br />
        {mapsLink ? (
          <a
            href="https://maps.app.goo.gl/ZhfR79M8nkRHVDeVA"
            target="_blank"
            rel="noreferrer"
          >
            184 Cambridge Science Park
          </a>
        ) : (
          <span>184 Cambridge Science Park</span>
        )}
        <br />
        Cambridge
        <br />
        CB4 0GA, United Kingdom
      </address>
    ),
    US: (
      <address>
        Nordic Innovation House
        <br />
        {mapsLink ? (
          <a
            href="https://maps.app.goo.gl/7w3t3DiTBZUEhw5P8"
            target="_blank"
            rel="noreferrer"
          >
            470 Ramona St
          </a>
        ) : (
          <span>470 Ramona St</span>
        )}
        <br />
        Palo Alto
        <br />
        94301 California
        <br />
        USA
      </address>
    ),
  }
}

const countryHasAddress = (
  addresses: object,
  country: string,
): country is AddressCountry =>
  Object.prototype.hasOwnProperty.call(addresses, country)

// Show local address with following precedence rules:
// 1. country defined in props, if present
// 2. geolocated visitor IP country, if we find one
// 3. Finland
const MeasurAddress = ({
  className,
  country,
  mapsLink = false,
}: {
  className?: string
  country?: AddressCountry
  mapsLink?: boolean
}) => {
  const geolocatedCountry = useGeolocation()
  const countryToShow = country ?? geolocatedCountry
  const allAddresses = useAddressesByCountry({ mapsLink })

  const address =
    countryToShow && countryHasAddress(allAddresses, countryToShow)
      ? allAddresses[countryToShow]
      : allAddresses.FI

  return (
    <div className={className}>
      Measurlabs
      <br />
      {address}
    </div>
  )
}

export default MeasurAddress
